import React from "react";

import TextileBackground from "../../components/TextileBackground";
import CinematicSection from "../../components/CinematicSection";
import CustomNavbar from "../../components/Navbar";
import Banner from "./components/Banner";
import MissionVisionValues from "./components/MissionVisionValues";
import CatalogueTeaser from "./components/CatalogueTeaser";
import SocialLinks from "./components/SocialLinks";
import FooterLinks from "../../components/FooterLinks";
import Footer from "../../components/Footer";

export default function Home() {
  return (
    <TextileBackground className="flex flex-col">
      <CustomNavbar overlay showBrand={false} />

      <CinematicSection zIndex={10} className="bg-cream-100/60" trackHeight="115vh" fitContent>
        <Banner />
      </CinematicSection>

      <CinematicSection zIndex={15} className="bg-cream-100/60" trackHeight="78vh" fitContent>
        <MissionVisionValues />
      </CinematicSection>

      <CinematicSection zIndex={25} className="bg-cream-100/60" trackHeight="65vh" fitContent>
        <CatalogueTeaser />
      </CinematicSection>

      <CinematicSection zIndex={40} className="bg-cream-100/60" trackHeight="65vh" fitContent>
        <SocialLinks />
      </CinematicSection>

      <FooterLinks />
      <Footer />
    </TextileBackground>
  );
}
